import PropTypes from "prop-types"

const BlankState = ({
  imageURL,
  buttonLabel,
  placeholderText,
  helpLinkURL,
  helpLinkText,
  onButtonClick = () => {},
  isSmallBlankSlate
}) => {
  return (
    <div className="mt-4">
      <div className="blank-state">
        {!isSmallBlankSlate && (
          <div className="blank-state__hero ta-c">
            <img src={imageURL} alt="No results" />
          </div>
        )}
        <div className="blank-state__msg blank-state__msg--wide">
          <div className="mb-2">{placeholderText}</div>
          {buttonLabel && (
            <div className="d-f jc-c">
              <button className="mr-2 create-btn btn2" onClick={onButtonClick}>
                {buttonLabel}
              </button>
              {helpLinkURL && (
                <a className="blank-state__link" href={helpLinkURL} target="_none">
                  {helpLinkText}
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

BlankState.propTypes = {
  imageURL: PropTypes.string,
  buttonLabel: PropTypes.string,
  onButtonClick: PropTypes.func,
  placeholderText: PropTypes.node,
  helpLinkURL: PropTypes.string,
  helpLinkText: PropTypes.string,
  isSmallBlankSlate: PropTypes.bool
}

export default BlankState
